import {
  CANCELISO,
  DELETEISO,
  DOWNLOADISO,
  GetISOList,
  UPLOADISO,
  UploadISOChunckingUI,
} from "../../../../../common/apiEndPoint/apiEndPoint";
import { config } from "../../../../../common/authentication/config";
import { store } from "../../../../../store";
import { apiClient } from "../../common/interceptor/base.services";
import { siteIdStatic, ACADEMY_TENANT_ID } from "../../file-management/store/file-management.service";
import { hideLoader, showToast } from "../../store/model/model.action";
import { uploadLoader } from "../store/iso-file-management.action";

export const getIsoList = (pageNumber: number) => {
  return apiClient.get(
    `${GetISOList}`,
    {
      headers: {
        siteid: siteIdStatic,
        orgId: ACADEMY_TENANT_ID,
        tenantId: config?.ACADEMY_TENANT_ID,
      },
    }
  );
};

export const uploadIsoFile = (data: any) => {
  return apiClient.post(`${UploadISOChunckingUI}`, data, {
    headers: {
      siteid: siteIdStatic,
      orgId: ACADEMY_TENANT_ID,
    },
   
  });
};

export const uploadIsoFileUpload = (data: any) => {
return apiClient.put(data.uploadUrl, data.chunkBlob, {
    headers: {
      "Content-Range": data.contentRange,
      "Content-Type": "application/octet-stream",
      "Authorization": `Bearer ${data.authorization}`,
    },
  });

}

export const deleteIsoList = (data: any) => {
  return apiClient.delete(`${DELETEISO}`, {
    data,
    headers: {
      siteid: siteIdStatic,
      orgId: ACADEMY_TENANT_ID,
    },
  });
};

export const downloadIsoFile = (data: any) => {
  return apiClient.post(`${DOWNLOADISO}`, data, {
    headers: {
      siteid: siteIdStatic,
      orgId: ACADEMY_TENANT_ID,
    },
  });
};

export const cancelUploadIsoFile = (data: any) => {
  return apiClient.post(`${CANCELISO}`, data, {
    headers: {
      siteid: siteIdStatic,
      orgId: ACADEMY_TENANT_ID,
    },
  });
};






export const downloadLargeFileWithFetch = async (downloadUrl: string, fileName: string) => {
  try {
   const link = document.createElement("a");
  link.href = downloadUrl; // Direct link to file (signed URL)
  link.setAttribute("download", fileName || "downloaded_file.iso");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  } catch (error) {
    console.error("Download failed", error);
    store.dispatch(showToast({ type: "error", content: "Download failed!" }));
  }
};

